import type { TicketFilters } from '../types/support';

export const ticketsKeys = {
  all: ['support', 'tickets'] as const,
  list: (filters: TicketFilters) =>
    ['support', 'tickets', 'list', JSON.stringify(filters)] as const,
  detail: (id: string) => ['support', 'tickets', 'detail', id] as const,
  mine: () => ['support', 'tickets', 'mine'] as const,
  metrics: (range: string) => ['support', 'metrics', range] as const,
  aiSuggestion: (id: string) => ['support', 'ai', id] as const,
};
